<template>
  <ErrorPageTemplate>
    Не удалось загрузить страницу,<br />попробуйте открыть ее позже.<br /><br />
    Вот тебе и отдохнули культурно...
  </ErrorPageTemplate>
</template>

<script setup lang="ts">
import { ErrorPageTemplate } from '@/6_shared/ui'
</script>
